export default {
  combine:{
    add_default_number: "@:ui.add @:ui.rednum",
    edit_default_number: "@:ui.edit @:ui.rednum",
    delete_default_number: "@:ui.delete @:ui.rednum",
    search_match_date: "@:ui.search @:ui.match_date",
    add_match_number: "@:ui.add @:ui.match_number",
    edit_match_number: "@:ui.edit @:ui.match_number",
    delete_match_number: "@:ui.delete @:ui.match_number",
    search_bet_list: "@:ui.search @:ui.bet_list",
  },
  app: "Back Office",
  list1: "Default Settings",
  list2: "Match Settings",
  change_password: "Change Password",
  rednum: "Red Number",
  ok: "OK",
  cancel: "Cancel",
  apply: "Apply",
  login: "Login",
  logout: "Logout",
  home: "Home",
  add: "Add",
  edit: "Edit",
  delete: "Delete",
  refresh: "Refresh",
  assign: "Assign",
  action: "Action",
  id: "ID",
  name: "Name",
  all: "All",
  search: "Search",
  remove: "Remove",
  save: "Save",
  load: "Load",
  account: "Account",
  settings: "Settings",
  on: "ON",
  off: "OFF",
  new: "New",
  clear: "Clear",
  system: "System",
  username: "Username",
  password: "Password",
  created_on: "Create On",
  active: "Active",
  disabled: "Disabled",
  blocked: "Blocked",
  suspended: "Suspended",
  page_size: "Page Size",
  no_data: "No Data Available",
  status: "Status",
  login_attempt: "Login Attempt",
  layout: "Layout",
  old_password: "Old Password",
  new_password: "New Password",
  confirm_password: "Confirm Password",

  default_number: "Default Number",
  match_number: "Match Number",
  company_list: "Company List",
  pool: "Pool",
  box: "Box",
  match_date: "Match Date",
  close: "Close",
  bet_list: "Bet List",
  bet_list_export: "@:ui.bet_list Export",
  export_excel: "Export To Excel",
};
